import React, { useEffect, useState } from "react";
import { Main, Content } from "../../../components/Layout";
import PresetBlock from "../../../components/PresetBlock";
import { Row, Col } from "react-bootstrap";
import api from "../../../services/api";
import styleButton from "../../../components/Button/Button.module.css";
import { ModalPermissionModel, ModalConfirm } from "../../../components/Modal";
import Loading from "../../../components/Loading";
import { toast } from "react-toastify";
import useWrapper from "../../../hooks/useWrapper";

export default function PresetsPermissions(props) {
  const { setbreadcrumb, config } = useWrapper();

  const [loaded, setloaded] = useState(false);
  const [reload, setreload] = useState(false);
  const [templates, settemplates] = useState();
  useEffect(() => {
    setloaded(false);
    (async function () {
      const _templates = await api.get("/template-permission", config);
      settemplates(
        _templates.data.map(__template => ({
          ...__template,
          permissions: JSON.parse(__template.permissions),
        })),
      );
      setloaded(true);
    })();
  }, [reload]);

  const [extraAction, setextraAction] = useState({
    action: null,
    id: null,
  });
  const [modelOpen, setmodelOpen] = useState(false);
  const confirmDelete = async () => {
    await api.delete(`/template-permission/${extraAction?.id}`, config);
    toast.success("Modelo apagado com sucesso!");
    setreload(!reload);
    setextraAction();
  };
  const confirmClone = async () => {
    const _template = await api.get(`/template-permission/${extraAction?.id}`, config);
    await api.post(
      "/template-permission",
      {
        name: `${_template.data.name} - Cópia`,
        description: _template.data.description,
        permissions: JSON.parse(_template.data.permissions),
      },
      config,
    );
    toast.success("Modelo clonado com sucesso!");
    setreload(!reload);
    setextraAction();
  };

  useEffect(() => {
    setbreadcrumb([{ label: "Administrativo" }]);
  }, []);

  return (
    <Main>
      <ModalPermissionModel
        show={modelOpen}
        onHide={() => {
          setmodelOpen(false);
        }}
        reload={reload}
        setreload={setreload}
      />
      <ModalConfirm
        show={extraAction?.action === "delete"}
        title="Apagar Modelo"
        text="Tem certeza que deseja apagar este modelo?"
        confirm={confirmDelete}
        closeModal={() => {
          setextraAction();
        }}
        colorScheme="error"
      />
      <ModalConfirm
        show={extraAction?.action === "clone"}
        title="Clonar Modelo"
        text="Tem certeza que deseja clonar este modelo?"
        confirm={confirmClone}
        closeModal={() => {
          setextraAction();
        }}
        colorScheme="primary"
      />
      {loaded ? (
        <Content>
          <Row>
            <Col sm={8}>
              <p className="page-title">Modelos de Permissões</p>
              <p className="sub-title">
                Crie modelos de permissões para usuários e acelere o gerenciamento de sua equipe!
              </p>
            </Col>
            <Col>
              <Col className="d-flex justify-content-end align-items-start">
                <button
                  className={styleButton.button_primary}
                  onClick={() => {
                    setmodelOpen("new");
                  }}
                >
                  Novo Modelo
                </button>
              </Col>
            </Col>
          </Row>
          <Row>
            {templates?.map(__template => (
              <Col xl={4} lg={6}>
                <PresetBlock
                  id={__template.id}
                  title={__template.name}
                  description={__template.description}
                  permissions={__template.permissions}
                  editPreset={ev => {
                    setmodelOpen(ev);
                  }}
                  clonePreset={() => {
                    setextraAction({
                      action: "clone",
                      id: __template.id,
                    });
                  }}
                  deletePreset={() => {
                    setextraAction({
                      action: "delete",
                      id: __template.id,
                    });
                  }}
                />
              </Col>
            ))}
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
